















































































































import Vue from "vue";
import { DateTime } from "luxon";
import { mapGetters } from "vuex";
import { Call } from "@/entities/call";
import { fmtDate, secondsToDuration } from "@/lib/filters";
import { httpByCurrentCustomer, downloadFromBlob } from "../../lib/client";
import mediaWaveSurfer from "@/components/calls/mediaWaveSurfer.vue";

export default Vue.extend({
  components: { mediaWaveSurfer },
  data() {
    return {
      page: 1, //Donde se ubicara la tabla al momento de renderizar
      pageCount: 0, // Contador de los elementos de la tabla
      itemsPerPage: 50, //Cantidad de item que se mostrara en la tabla
      selectCall: [] as Array<Call>,
      dialog: false,
      search: "",
      callSelected: {} as Call,
      isDownloadingAudio: false,
      isDownloadingPcap: false,
      headers: [
        {
          text: "Fecha",
          align: "left",
          sortable: true,
          value: "callTime",
        },
        { text: "Número Telefonico", value: "phone", sortable: "false" },
        { text: "Duración", value: "duration", sortable: "true" },
        { text: "Etiquetas", value: "tags", sortable: "false" },
        { text: "Rec", value: "recUrl", sortable: "false" },
        { text: "", value: "action", sortable: "false" },
      ],
      showAudioAlert: false,
      showError: false,
      textError: "",
    };
  },
  methods: {
    tablePager(item: any) {
      //Aqui se realiza la busqueda del ultimo elemento del array actual para la paginacion.
      const arrayList = this.calls as any;
      if (arrayList.length >= 5000) {
        if (item.page > item.pageCount - 5) {
          this.$emit("lastId", arrayList[arrayList.length - 1].callTime);
        }
      }
    },
    audioDownload(item: any) {
      this.callSelected = item;
      const urlBase = `calls/${this.callSelected.id}/audio`;
      this.isDownloadingAudio = true;
      this.$store.dispatch("updateAudioDownloadStatus", {
        id: this.callSelected.id,
        status: true,
      });
      httpByCurrentCustomer()
        .get(urlBase)
        .blob()
        .then((res) => {
          downloadFromBlob(
            res,
            `${DateTime.fromISO(this.callSelected.callTime as string).toFormat(
              "yyyyMMddhm"
            )}_${this.callSelected.phone}.mp3`
          );
          this.$store.dispatch("updateAudioDownloadStatus", {
            id: this.callSelected.id,
            status: false,
          });
        })
        .catch(() => {
          this.$store.dispatch("updateAudioDownloadStatus", {
            id: item.id,
            status: false,
          });
          this.textError = "No fue posible descargar el audio.";
          this.showError = true;
        });
    },
    pcapDownload(item: any) {
      this.callSelected = item;
      const urlBase = `calls/${this.callSelected.id}/pcaps`;
      this.$store.dispatch("updatePcapDownloadStatus", {
        id: this.callSelected.id,
        status: true,
      });
      httpByCurrentCustomer()
        .get(urlBase)
        .blob()
        .then((res) => {
          downloadFromBlob(
            res,
            `${DateTime.fromISO(this.callSelected.callTime as string).toFormat(
              "yyyyMMddhm"
            )}_${this.callSelected.phone}.pcap`
          );
          this.$store.dispatch("updatePcapDownloadStatus", {
            id: this.callSelected.id,
            status: false,
          });
        })
        .catch(() => {
          this.$store.dispatch("updatePcapDownloadStatus", {
            id: item.id,
            status: false,
          });
          this.textError = "No fue posible descargar el pcap.";
          this.showError = true;
        });
    },
    async openRec(item: Call) {
      this.callSelected = item;
      this.dialog = true;
    },
    selectedTag(tag: string) {
      this.$emit("selectedTag", tag);
    },
    selectItem(item: any) {
      let allId = [];
      allId = item.map((e: any) => e.id);
      this.$emit("selectCall", allId);
    },
    nextCall(calls: any) {
      const idx = calls.indexOf(this.callSelected);
      if (idx < calls.length - 1) {
        this.callSelected = calls[idx + 1];
      } else {
        this.showAudioAlert = true;
      }
    },
    previousCall(calls: any) {
      const idx = calls.indexOf(this.callSelected);
      if (idx > 0) {
        this.callSelected = calls[idx - 1];
      } else {
        this.showAudioAlert = true;
      }
    },
  },
  computed: {
    ...mapGetters({ loading: "callsLoading" }),
  },
  props: {
    calls: [],
  },
  filters: {
    fmtDate,
    secondsToDuration,
  },
});
